/**
 * 封装axios
 */
import axios from "axios";

axios.defaults.baseURL = "https://open.mini.xiaomaiot.com/datav/v2/api";
// axios.defaults.baseURL = "https://192.168.50.43:6006/datav/v2/api";


export default axios;
